import React, { Component, useState, useEffect } from "react";
import {
  Grid,
  Avatar,
  Button,
  ButtonGroup,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Backdrop,
  MenuItem,
  Typography,
} from "@material-ui/core";
import Hidden from "@material-ui/core/Hidden";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import TextField from "@material-ui/core/TextField";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import "./UserProfile.css";
import { fetchProfile } from "../../../redux/dataFetchers/ProfileApi";
import { withRouter } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import CircularProgress from '@material-ui/core/CircularProgress';
import Swal from "sweetalert2";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    width: "70%",
  },
  saveBtn: {
    display: "flex",
    width: "60%",
    justifyContent: "space-between",
  },
  experience: {
    display: "flex",
    width: "70%",
  },
}));

const About = React.forwardRef(({ user }, aboutRef) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [expYears, setExpYears] = useState(user?.experience?.years || 0);
  const [expMonths, setExpMonths] = useState(user?.experience?.months || 0);
  const [name, setName] = useState(user.name);
  const [industry, setIndustry] = useState(user.industry);
  const [about, setAbout] = useState(user.description);
  const [editPanel, setEditPanel] = useState(false);
  const experiences = [
    {
      value: "1",
      label: "1 month",
    },
    {
      value: "2",
      label: "2 months",
    },
    {
      value: "3",
      label: "3 months",
    },
    {
      value: "4",
      label: "4 months",
    },
    {
      value: "5",
      label: "5 months",
    },
    {
      value: "6",
      label: "6 months",
    },
    {
      value: "7",
      label: "7 months",
    },
    {
      value: "8",
      label: "8 months",
    },
    {
      value: "9",
      label: "9 months",
    },
    {
      value: "10",
      label: "10 months",
    },
    {
      value: "11",
      label: "11 months",
    },
    {
      value: "12",
      label: "12 months",
    },
  ];

  const openEditPanel = () => {
    setEditPanel(true);
  };

  aboutRef.current = openEditPanel;

  const closeEditPanel = () => {
    setEditPanel(false);
  };

  const saveUserDetails = () => {
    if (!name) {
      return Swal.fire({
        icon: "error",
        text: "Name is empty!",
        timer: 2500,
      });
    }

    const token = localStorage.getItem("token");
    fetch(`https://recruitingmonk-v2.azurewebsites.net/update`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      method: "PUT",
      body: JSON.stringify({
        uid: user.uid,
        name,
        about,
        industry,
        experience: {
          years: expYears,
          months: expMonths,
        },
      }),
    })
      .then((response) => {
        if (response.ok) {
          console.log(response);
          return response;
        } else {
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      })
      .then((response) => response.json())
      .then((response) => {
        setExpYears();
        if (response.success) {
          console.log(response.msg);
          closeEditPanel();
          dispatch(fetchProfile())
          return Swal.fire({
            icon: "success",
            title: "Done",
            text: "Changes Saved Successfully",
          });
        } else throw new Error("Some Error occurred");
      })
      .catch((error) => console.log(error));
  };
  console.log(user);
  return (
    <div style={{ paddingRight: "20px" }}>
      <p style={{ paddingLeft: "16px", color: "gray" }}>{user.description}</p>
      <List>
        <ListItem>
          <ListItemText
            disableTypography
            primary={
              <Typography type="body2" style={{ fontWeight: "bold", fontSize:"1.1rem" }}>
                Industry
              </Typography>
            }
            secondary={
              <Typography type="body2" style={{ color: "gray" }}>
                {user.industry || ""}
              </Typography>
            }
          />
        </ListItem>
        <ListItem>
          <ListItemText
            disableTypography
            primary={
              <Typography type="body2" style={{ fontWeight: "bold", fontSize:"1.1rem" }}>
                Total Work Experience
              </Typography>
            }
            secondary={
              <Typography type="body2" style={{ color: "gray" }}>
                {user?.experience?.years +
                  " years, " +
                  user?.experience?.months +
                  " months"}
              </Typography>
            }
          />
        </ListItem>
        <ListItem>
          <ListItemText
            disableTypography
            primary={
              <Typography type="body2" style={{ fontWeight: "bold", fontSize:"1.1rem" }}>
                Role
              </Typography>
            }
            secondary={
              <Typography type="body2" style={{ color: "gray" }}>
                {user.role || ""}
              </Typography>
            }
          />
        </ListItem>
      </List>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={editPanel}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade
          in={editPanel}
          className="flex flex-col items-center p-4 w-5/6 md:w-1/3"
        >
          <div
            className="px-6"
            style={{
              backgroundColor: "#eccdb2",
              borderRadius: "5px",
            }}
          >
            <div
              className="flex flex-col items-center gap-3 w-full"
              style={{ padding: "1rem 0" }}
              id="transition-modal-title"
            >
              <div className={classes.inputContainer}>
                <TextField
                  id="standard-multiline-static"
                  label="About"
                  multiline
                  rows={3}
                  defaultValue={user.description}
                  variant="standard"
                  onChange={(event) => setAbout(event.target.value)}
                />
              </div>
              <div className={classes.inputContainer}>
                <TextField
                  id="standard-multiline-static"
                  label="Name"
                  defaultValue={user.name}
                  variant="standard"
                  onChange={(event) => setName(event.target.value)}
                />
              </div>
              <div className={classes.inputContainer}>
                <TextField
                  id="standard-multiline-static"
                  label="Industry"
                  defaultValue={user.industry || ""}
                  variant="standard"
                  onChange={(event) => setIndustry(event.target.value)}
                />
              </div>
              <div className={classes.experience}>
                <TextField
                  id="standard-multiline-static"
                  label="Years"
                  defaultValue={user?.experience?.years || ""}
                  variant="standard"
                  onChange={(event) => setExpYears(event.target.value)}
                />
                <TextField
                  id="outlined-select-experience"
                  select
                  label="Months"
                  value={expMonths}
                  onChange={(event) => setExpMonths(event.target.value)}
                  style={{ width: "50%" }}
                >
                  {experiences.map((option) => (
                    <MenuItem key={option.value} value={option.value} selected={option.value == expMonths?true:false} >
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              <div className={classes.saveBtn}>
                <Button
                  className=""
                  style={{
                    fontWeight: "bold",
                    color: "white",
                    background: "#B0343C",
                    float: "left",
                  }}
                  variant={"contained"}
                  onClick={saveUserDetails}
                >
                  Save
                </Button>
                <Button
                  className=""
                  style={{
                    fontWeight: "bold",
                    color: "white",
                    background: "#B0343C",
                  }}
                  variant={"contained"}
                  onClick={closeEditPanel}
                >
                  Discard
                </Button>
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
});

function SavedFeed() {
  const reduxState = useSelector(state => state);
  const [savedFeed, setSavedFeed] = useState(reduxState.info.info.feed || []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    fetch(`https://recruitingmonk-v2.azurewebsites.net/feed/savedfeed`,{
      headers:{
        'Content-Type':'application/json',
        Authorization:token,
      },
      method:'GET',
    })
    .then(response => {
      if(response.ok) {
          console.log(response)
          return response;
      }
      else {
          var error = new Error("Error " + response.status + ": " + response.statusText);
          error.response = response;
          throw error;
      }
  }).then(response => response.json())
  .then(response => {
    return setSavedFeed(response.feed);
  })
  .catch(error => {
    console.log(error);
  })
  },[])

  const redirectToFeed = (feed) => {
    switch(feed.tag){
      case 'post':
        window.location.href = `https://recruitingmonk-app.azurewebsites.net/posts/${feed.id}`;
        break;
      case 'qna':
        window.location.href = `https://recruitingmonk-app.azurewebsites.net/qnas/${feed.id}`;
        break;
      case 'poll':
        window.location.href = `https://recruitingmonk-app.azurewebsites.net/polls/${feed.id}`;
        break;
      default:
    }
  }
  return (
    <div className="saved-feed">
      {savedFeed.map((feed) => (
        <div className="flex flex-col p-2 md:mx-2 mb-5 rounded-xl bg-white shadow-xl md:bg-transparent md:shadow-none glass saved-feed-item"
          onClick={() => redirectToFeed(feed)} >
          <div className="flex flex-col mb-2">
            <div className="flex flex-col gap-2 justify-start">
              <Typography
                variant="h5"
                color="textPrimary"
                style={{ whiteSpace: "pre-line",textAlign:'left' }}
                component="p"
              >
                {feed.title}
              </Typography>
              <hr/>
              <div className="mt-3 px-1">
                <Typography
                  variant="body1"
                  color="textPrimary"
                  style={{ whiteSpace: "pre-line" }}
                  component="p"
                >
                  {feed.content}
                </Typography>
              </div>
              <div className="feed-tag" >{feed.tag === 'post'? 'post':
                                            feed.tag === 'qna'? 'question': 'poll'}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      className="profile-mob-tabs-info"
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

class UserProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      info: {},
      value: 0,
    };

    this.handleChange = this.handleChange.bind(this);
    this.openEditPanel = this.openEditPanel.bind(this);
    this.aboutRef = React.createRef();
  }

  handleChange = (event, index) => {
    this.setState({
      value: index,
    });
  };

  openEditPanel() {
    this.aboutRef.current();
  }

  componentDidMount() {
    let pathname = this.props.history.location.pathname.split('/');
    const userId = pathname[2];

    if(userId){
      fetch(`https://recruitingmonk-v2.azurewebsites.net/user/${userId}`,{
        header:{
          'Content-Type':'applicatin/json',
        },
        method:'GET',
      }) .then((response) => {
        if (response.ok) {
          console.log(response);
          return response;
        } else {
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      })
      .then((response) => response.json())
      .then(response => {
        this.setState({info:response.user,index:1});
      }).catch(error => {
        window.location.href = window.location.origin;
        console.log(error);
      })
    }
    else if(!this.props.authUser.isAuthenticated)
      window.location.href = window.location.origin;
  }

  render() {
    return (
      <>
        {this.state.info.uid || this.props.authUser.isAuthenticated ? (
          <div className="profile-page">
            <Grid container className="profile-bg">
              <Grid align="center" item xs={12} style={{ marginBottom: "8px" }}>
                <Avatar
                  style={{ width: "75px", height: "75px" }}
                  alt=""
                  src={this.state.info.uid? this.state.info.avatar:this.props.info.info.avatar}
                />
              </Grid>
              <Grid
                align="center"
                className="username"
                item
                xs={12}
                style={{ marginBottom: "8px", fontSize:'1.3rem' }}
              >
                {this.state.info.uid? this.state.info.name:this.props.info.info.name}
              </Grid>
              <Grid item align="center" xs={12}>
                <ButtonGroup
                  size="small"
                  aria-label="small outlined button group"
                >
                </ButtonGroup>
              </Grid>

              {/* Profile Mobile Tabs */}

              <Hidden mdUp>
                <Grid item xs={12}>
                  <Tabs
                    value={this.state.value}
                    onChange={this.handleChange}
                    aria-label="profile tabs"
                    className="profile-mob-tabs"
                  >
                  {!this.state.info.uid &&
                    <Tab
                      label="Saved Feed"
                      className="profile-mob-tabs-heading"
                    />
                  }
                    <Tab label="About" className="profile-mob-tabs-heading" />
                    {this.state.value === 1 && !this.state.info.uid && (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <EditOutlinedIcon
                          style={{
                            color: "#B0343C",
                            borderRadius: "50%",
                            boxShadow: "2px 2px 2px 2px solid gray",
                            border: "1px solid #B0343C",
                            background: "white",
                            cursor: "pointer",
                            padding: "0.1rem",
                          }}
                          onClick={this.openEditPanel}
                        />
                      </div>
                    )}
                  </Tabs>
                </Grid>
              </Hidden>
            </Grid>

            {/* Profile Mobile Panels */}
            <Hidden mdUp>
            {!this.state.info.uid &&
              <TabPanel value={this.state.value} index={0}>
                <SavedFeed />
              </TabPanel>
            }
              <TabPanel value={this.state.value} index={this.state.info.uid?0:1}>
                <About user={this.state.info.uid?this.state.info:this.props.info.info} ref={this.aboutRef} />
              </TabPanel>
            </Hidden>

            {/* Profile Tabs for medium to xl screens */}
            <Hidden smDown>
              <Grid container className="profile-info-bg profile-desktop">
                {!this.state.info.uid && 
                <Grid
                  className="profile-info-contributions"
                  item
                  xs={12}
                  md={6}
                >
                  <h3 style={{fontSize:'1.3rem',margin:'1rem'}}>Saved Feed</h3>
                  <SavedFeed />
                </Grid>
                }
                <Grid className="profile-info-about" item xs={12} md={6}>
                  <h3
                    style={{
                      fontWeight: "bold",
                      fontSize:"1.3rem",
                      margin: "0.5rem 0",
                      padding: "0.3rem",
                    }}
                  >
                    About{" "}
                    {!this.state.info.uid && 
                    <EditOutlinedIcon
                      style={{
                        color: "#B0343C",
                        borderRadius: "50%",
                        boxShadow: "2px 2px 2px 2px solid gray",
                        border: "1px solid #B0343C",
                        cursor: "pointer",
                        padding: "0.1rem",
                      }}
                      onClick={this.openEditPanel}
                    />}
                  </h3>
                  <About user={this.state.info.uid?this.state.info:this.props.info.info} ref={this.aboutRef} />
                </Grid>
              </Grid>
            </Hidden>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
              height: "80vh",
              fontWeight: "bold",
              fontSize: "2rem",
            }}
          ><CircularProgress style={{color:'#B0343C'}} /></div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  info: state.info,
  authUser: state.authUser,
});

const mapDispatchToProps = (dispatch) => ({
  fetchProfile: () => {
    dispatch(fetchProfile());
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserProfile)
);
